import React from 'react';
import Timeline from '../../../../assets/images/timeline.png';

import { Image, Title, Text } from './styles';

export const News = () => {
  return (
    <>
      <Title>
        Agora você pode visualizar o <span>status da análise da proposta</span>
      </Title>
      <Text>
        Mais visibilidade e transparência para você fazer um acompanhamento em
        tempo real. Basta <strong>acessar suas propostas em análise</strong> e
        conferir essa novidade!
      </Text>
      <Image
        src={Timeline}
        alt="Imagem mostrando a nova timeline na lista de detalhes de uma proposta"
      />
    </>
  );
};
